module.exports = __webpack_public_path__ + "img/icwithdraw.f6ece3cc.png";